import React from 'react';
import { TextField } from '@mui/material';

/**
 * DiscussionTextarea Component
 * Text area for adding discussion/notes updates
 *
 * @param {string} value - Current discussion text
 * @param {function} onChange - Callback when text changes
 * @param {string} label - Label for the textarea
 * @param {boolean} error - Whether to show error state
 * @param {string} helperText - Inline validation message
 */
const DiscussionTextarea = ({ value, onChange, label = 'Update Discussion', error = false, helperText = '' }) => {
  return (
    <TextField
      label={label}
      multiline
      rows={3}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      error={error}
      helperText={helperText}
      fullWidth
      size="small"
      sx={{ mb: 0 }}
      placeholder="Add your discussion notes here..."
    />
  );
};

export default DiscussionTextarea;

